// KEEP IN SYNC with REJECT_REASONS in functions/_shared/review.js (the server validates the code).
export const REJECT_REASONS = [
  { id: "duplicate", label: "Duplicate of a wreck that's already on the map" },
  { id: "location", label: "The location looks wrong" },
  { id: "scope", label: "Not a shipwreck, or out of scope for this map" },
  { id: "sources", label: "Needs sources or links to back it up" },
  { id: "photo", label: "Photo credit or licence is missing or not acceptable" },
  { id: "quality", label: "Too incomplete or unclear to publish yet" },
  { id: "inappropriate", label: "Spam or inappropriate content" },
  { id: "other", label: "Other (explain below)" },
];
export const MAX_REJECT_NOTE = 500;
